module.exports = __webpack_public_path__ + "img/main-big.1aa00651.jpg";